module.exports = __webpack_public_path__ + "img/integral.f0713de2.png";